class CartDrawerController {
  constructor() {
    this.cartDrawer = document.getElementById("cart-drawer-custom");
    if (this.cartDrawer) {
      window.custom_cart_drawer = true;
    }
    this._drawerUpdateTimer = null;
    this._drawerAbortController = null;
    this._fgpRunCheckTimer = null;
    this.openCartButtons = document.querySelectorAll("open-minicart");
    this.init();
  }

  init() {
    this.initOpenCart();
    this.initCloseCart();
    this.initQuantityButtons();
    this.updateQuantityButtonStates();
    this.initRecommendedButtons();
    this.initRecommendedSwiper();
    this.removeCartItem();
    this.applyCoponCode();
    this.initPriceUpdate();
    window.updateCustomCartDrawer = (freshCart) => {
      return this.updateCartDrawer(freshCart);
    };
    this.getCartData();
    this.initFreeGiftButtons();
    this.initProductOfferCheckbox();
    this.initOfferCountdown();
    /* window.fgpCartData is a synchronous, server-rendered cart snapshot (set by an
     * inline, non-deferred <script> in cart-drawer-section.liquid, which always runs
     * before this deferred script per HTML parsing order) — the same data /cart.js
     * would return at this instant. Reusing it lets removeUpsellIfAlone skip its
     * page-load fetch when free-gift-progress is enabled; falls back to fetching
     * exactly as before when it isn't (window.fgpCartData is undefined then). */
    this.updateCartDrawer(window.fgpCartData || null);
    this._fgpSetupMutex();
    this._fgpInitialize();
  }

  disableCheckout = () => {
    const checkoutWrapper = document.querySelector(
      ".gokwik-checkout-wrapper-button"
    );
    const checkoutButton = checkoutWrapper?.querySelector("button");
    checkoutWrapper?.classList.add("disabled");
    if (checkoutButton) {
      checkoutButton.style.pointerEvents = "none";
    }
  };

  enableCheckout = () => {
    const checkoutWrapper = document.querySelector(
      ".gokwik-checkout-wrapper-button"
    );
    const checkoutButton = checkoutWrapper?.querySelector("button");
    checkoutWrapper?.classList.remove("disabled");
    if (checkoutButton) {
      checkoutButton.style.pointerEvents = "auto";
    }
  };

  initFreeGiftButtons = () => {
    // Open free gift drawer button
    const freeGiftDrawer = document.getElementById("free-gift-drawer");
    const openFreeGiftButton = document.getElementById("open-free-gift");
    if (openFreeGiftButton) {
      openFreeGiftButton.addEventListener("click", () => {
        if (freeGiftDrawer) {
          freeGiftDrawer.classList.add("active");
        }
      });
    }

    // Close free gift drawer button
    const closeFreeGiftButton = document.getElementById("close-free-gift");
    if (closeFreeGiftButton) {
      closeFreeGiftButton.addEventListener("click", () => {
        if (freeGiftDrawer) {
          freeGiftDrawer.classList.remove("active");
        }
      });
    }

    // Add free gift buttons
    this.initAddFreeGiftButtons();
  };

  initAddFreeGiftButtons = () => {
    const addFreeGiftButtons = document.querySelectorAll(".add-free-gift-btn");

    addFreeGiftButtons.forEach((button) => {
      button.addEventListener("click", () => {
        button.style.pointerEvents = "none";
        button.style.opacity = "0.5";
        let variantId;

        if (button.getAttribute("data-variant-id")) {
          // Direct variant ID
          variantId = parseInt(button.getAttribute("data-variant-id") || "0");
        } else if (button.getAttribute("data-product-id")) {
          // Get variant ID from select
          const productId = button.getAttribute("data-product-id");
          const select = document.querySelector(
            `.free-gift-select[data-product-id="${productId}"]`
          );
          if (select) {
            variantId = parseInt(select.value);
          }
        }

        if (variantId) {
          // Show loading state
          const parent = button.closest(".free-gift-items");
          const childParent = button.closest(".free-gift-item");
          if (childParent) {
            childParent.classList.add("loading");
          }
          if (parent) {
            parent.classList.add("desable");
          }

          // Add the free gift
          this.addFreeGift(variantId);
        }
      });
    });
  };

  addExtraGift = async () => {
    const freeGift = window.freeGifts.onerupeeProduct;
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: freeGift,
          quantity: 1,
          properties: {
            _extra_gift: true,
          },
        }),
      });
    } catch (error) {
      console.error("Error adding free gift:", error);
    } finally {
      window.updateCustomCartDrawer();
    }
  };

  addFreeGift = async (variantId) => {
    const freeGift = variantId;

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: freeGift,
          quantity: 1,
          properties: {
            _free_gift: true,
          },
        }),
      });
    } catch (error) {
      console.error("Error adding free gift:", error);
    } finally {
      window.updateCustomCartDrawer();
      const freeGiftDrawer = document.getElementById("free-gift-drawer");
      const freeGIF = document.querySelector(".cart-drawer-custom .gif-icon");
      if (freeGIF) {
        freeGIF.classList.add("active");
      }
      setTimeout(() => {
        if (freeGIF) {
          freeGIF.classList.remove("active");
        }
      }, 2000);
      if (freeGiftDrawer) {
        freeGiftDrawer.classList.remove("active");
      }
    }
  };

  checkoutButtonDisabled = () => {
    if (document.querySelector(".gokwik-checkout-wrapper-button")) {
      document
        .querySelector(".gokwik-checkout-wrapper-button")
        .classList.add("disabled");
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['pointer-events'] = "none";
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['background'] = "#c6c0c0";
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['background'] = "#000";
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['cursor'] = "not-allowed";
      // document.querySelector(".gokwik-checkout").style['background'] = "#c6c0c0";
    }
  };
  removeCheckoutButtonDisabled = () => {
    if (document.querySelector(".gokwik-checkout-wrapper-button")) {
      document
        .querySelector(".gokwik-checkout-wrapper-button")
        .classList.remove("disabled");
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['pointer-events'] = "auto";
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['background'] = "#000";
      // document.querySelector(".gokwik-checkout-wrapper-button button").style['cursor'] = "pointer";
      // document.querySelector(".gokwik-checkout").style['background'] = "#000";
    }
  };

  /* Lazily delegates to the shared mutex set up by the FGP handlers in this file.
   * Falls back to a plain Promise if fgp system is not loaded. */
  _withGiftLock = (fn) => {
    if (typeof window._withGiftLock === 'function' && window._withGiftLock !== this._withGiftLock) {
      return window._withGiftLock(fn);
    }
    return Promise.resolve().then(fn);
  };

  /* Remove by stable item.key — not by 1-based line index which shifts
   * whenever other items are added/removed concurrently. */
  removeFreeGift = async (itemKey) => {
    this.checkoutButtonDisabled();
    let latestCart;
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((cartData) => {
        /* /cart/change.js already returns the full cart — capture it instead
         * of discarding it, so the drawer refresh can reuse it. */
        latestCart = cartData;
      })
      .catch((error) => {
        console.error("Error removing free gift:", error);
      })
      .finally(() => {
        window.updateCustomCartDrawer(latestCart);
        this.removeCheckoutButtonDisabled();
      });
  };

  getCartData = async () => {
    this.checkoutButtonDisabled();
    try {
      fetch("/cart.js", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin", // Ensures session/cookies are sent
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((cart) => {
          if (window.freeGifts.isFreeGift) {
            this.checkFreeGift(cart);
          }
          if (window.freeGifts.onerupeeProductEnable) {
            this.checkExtraGift(cart);
          }
          this.removeCheckoutButtonDisabled();
          // You can access cart.items, cart.total_price, etc.
        });
    } catch (error) {
      console.error("Error fetching cart:", error.message || error);
      return null;
    }
  };

  checkFreeGift = (cart) => {
    const FREE_GIFT_THRESHOLD = window.freeGifts.price;
    let hasFreeGift    = false;
    let freeGiftKey    = null;
    let freeGiftPrice  = 0;

    /* Collect the first free-gift item — handle both boolean and string property */
    cart.items.forEach((item) => {
      if (!hasFreeGift && item.properties &&
          (item.properties._free_gift === 'true' || item.properties._free_gift === true)) {
        hasFreeGift   = true;
        freeGiftKey   = item.key;          /* stable identifier */
        freeGiftPrice = item.line_price || 0;
      }
    });

    const cartTotal = Math.max(0, cart.total_price - freeGiftPrice);

    if (cartTotal >= FREE_GIFT_THRESHOLD) {
      if (!hasFreeGift) this.removeCheckoutButtonDisabled();
      return;
    }

    /* Below threshold — remove the gift inside the shared lock so it
     * doesn't race with the FGP gift processor.
     * Re-fetch cart inside the lock to confirm the gift is still present
     * before sending the remove request. */
    if (hasFreeGift && freeGiftKey) {
      const keyToRemove = freeGiftKey;
      this._withGiftLock(() =>
        fetch('/cart.js')
          .then((r) => r.json())
          .then((freshCart) => {
            const stillPresent = freshCart.items.some((item) => item.key === keyToRemove);
            if (stillPresent) return this.removeFreeGift(keyToRemove);
          })
          .catch((err) => console.error('[CD] checkFreeGift remove error:', err))
      );
    }
  };

  checkExtraGift = (cart) => {
    this.checkoutButtonDisabled();
    const FREE_GIFT_THRESHOLD = 100;
    let hasExtraGift  = false;
    let extraGiftKey  = null;

    cart.items.forEach((item) => {
      if (!hasExtraGift && item.properties && item.properties._extra_gift) {
        hasExtraGift = true;
        extraGiftKey = item.key; /* stable identifier */
      }
    });

    const cartTotal = cart.total_price;

    if (cartTotal >= FREE_GIFT_THRESHOLD) {
      if (!hasExtraGift) {
        this.removeCheckoutButtonDisabled();
        return this.addExtraGift();
      }
    } else {
      if (hasExtraGift && extraGiftKey) {
        this.removeCheckoutButtonDisabled();
        return this.removeFreeGift(extraGiftKey);
      }
      this.removeCheckoutButtonDisabled();
    }
  };

  // Add free gift to cart

  // Remove free gift from cart

  initPriceUpdate() {
    const selects = document.querySelectorAll(".recommended-select");

    selects.forEach((select) => {
      select.addEventListener("change", function () {
        const parent = this.closest(".recommended-product");
        const priceDiv = parent.querySelector(".recommended-price");
        const compareAtPriceDiv = parent.querySelector(".recommended-compare-at-price");
        const selectedOption = this.options[this.selectedIndex];
        const variantPrice = selectedOption.getAttribute("data-variant-price");
        const variantCompareAtPrice = selectedOption.getAttribute("data-variant-compare-at-price");

        const formatPrice = (price) => {
          return parseFloat(price / 100).toFixed(2).replace(/\.00$/, ''); // Remove trailing ".00"
        };

        const formattedPrice = formatPrice(variantPrice);
        priceDiv.innerHTML = `Rs. ${formattedPrice}`;

        if (compareAtPriceDiv) {
          const formattedCompareAtPrice = formatPrice(variantCompareAtPrice);
          compareAtPriceDiv.innerHTML = `Rs. ${formattedCompareAtPrice}`;
        }
      });
    });
  }

  initOpenCart() {
    const openCartButtons = document.querySelectorAll("open-minicart");
    openCartButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const overlay = document.querySelector(
          ".cart-drawer-section .cart-overlay"
        );
        if (overlay) {
          overlay.classList.add("active");
        }
        this.cartDrawer.classList.add("active");
        document.body.classList.add("overflow-hidden");
        document.documentElement.classList.add("overflow-hidden");
      });
    });
  }

  initCloseCart() {
    const closeCartButton = document.getElementById("close-cart");
    const overlayClose = document.querySelector(
      ".cart-drawer-section .cart-overlay"
    );
    const cart_drawer = document.getElementById("cart-drawer-custom");
    if (closeCartButton) {
      closeCartButton.addEventListener("click", () => {
        const overlay = document.querySelector(
          ".cart-drawer-section .cart-overlay"
        );
        if (overlay) {
          overlay.classList.remove("active");
        }
        cart_drawer.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        document.documentElement.classList.remove("overflow-hidden");
      });
    }
    if (overlayClose) {
      overlayClose.addEventListener("click", () => {
        const overlay = document.querySelector(
          ".cart-drawer-section .cart-overlay"
        );
        if (overlay) {
          overlay.classList.remove("active");
        }
        cart_drawer.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        document.documentElement.classList.remove("overflow-hidden");
        const freeGiftDrawer = document.getElementById("free-gift-drawer");
        freeGiftDrawer.classList.remove("active");
      });
    }
  }

  initQuantityButtons() {
    const quantityButtons = document.querySelectorAll(".quantity-btn");
    quantityButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const input = button.parentNode.querySelector("input");
        const parent = button.closest(".cart-item");
        
        const productLimit = parseInt(parent && parent.getAttribute('data-product-limit')) || 999;
        const currentValue = parseInt(input.value);
        
        if (button.dataset.action === "increase" && currentValue >= productLimit) {
          return;
        }
        
        this.checkoutButtonDisabled();
        const loder = parent.querySelector(".cart-loader");
        if (parent && loder) {
          parent.classList.add("loading");
          loder.classList.add("active");
        }
        console.log(currentValue, "currentValue");
        if (button.dataset.action === "increase") {
          input.value = currentValue + 1;
        } else if (button.dataset.action === "decrease" && currentValue >= 1) {
          input.value = currentValue - 1;
        }
        this.disableCheckout();
        this.updateCartItem(button.dataset.line, input.value);
      });
    });
  }

  updateQuantityButtonStates() {
    const cartItems = document.querySelectorAll(".cart-item");
    cartItems.forEach((cartItem) => {
      const productLimit = parseInt(cartItem.getAttribute('data-product-limit')) || 999;
      const quantityInput = cartItem.querySelector('.quantity-input');
      const increaseButton = cartItem.querySelector('.quantity-btn[data-action="increase"]');
      
      if (quantityInput && increaseButton) {
        const updateButtonState = () => {
          const currentValue = parseInt(quantityInput.value) || 0;
          
          if (currentValue >= productLimit) {
            increaseButton.disabled = true;
            increaseButton.style.opacity = '0.5';
            increaseButton.style.cursor = 'not-allowed';
          } else {
            increaseButton.disabled = false;
            increaseButton.style.opacity = '1';
            increaseButton.style.cursor = 'pointer';
          }
        };
        
        updateButtonState();
        
        // Add input listener for manual changes
        quantityInput.removeEventListener('input', updateButtonState);
        quantityInput.addEventListener('input', updateButtonState);
      }
    });
  }

  removeCartItem() {
    const removeButtons = document.querySelectorAll(".remove-item");
    removeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.checkoutButtonDisabled();
        const line = button.dataset.line;
        const parent = button.closest(".cart-item");
        const loder = parent.querySelector(".cart-loader");
        if (parent && loder) {
          parent.classList.add("loading");
          loder.classList.add("active");
        }
        this.disableCheckout();
        this.updateCartItem(line, 0);
      });
    });
  }

  initRecommendedSwiper() {
    const container = document.querySelector('.recommended-swiper');
    if (!container) return;

    if (this._recommendedSwiper) {
      this._recommendedSwiper.destroy(true, true);
      this._recommendedSwiper = null;
    }

    if (typeof Swiper === 'undefined') return;

    this._recommendedSwiper = new Swiper('.recommended-swiper', {
      slidesPerView: 1.10,
      spaceBetween: 12,
      pagination: {
        el: '.recommended-pagination',
        clickable: true,
      },
    });
  }

  initRecommendedButtons() {
    const recommendedButtons = document.querySelectorAll(".add-recommended");
  
    recommendedButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.dataset.variantId; // for default variant case
        const productId = button.dataset.productId; // for multi-variant case
  
        const parent = button.closest(".recommended-product");
        const loader = parent?.querySelector(".cart-loader");
  
        if (parent && loader) {
          parent.classList.add("loading");
          loader.classList.add("active");
        }
  
        let selectedVariantId = variantId || null;
        if (!selectedVariantId && productId) {
          const select = document.querySelector(
            `select[data-product-id="${productId}"]`
          );
          selectedVariantId = select ? select.value : null;
        }
  
        if (selectedVariantId) {
          this.addToCart(selectedVariantId, 1);
        }
      });
    });
  }

  initOfferCountdown() {
    const wrapper = document.querySelector('.product-offer-wrapper[data-end-date]');
    if (!wrapper) return;

    const countdownEl = document.getElementById('offer-countdown');
    if (!countdownEl) return;

    const endDate = new Date(wrapper.getAttribute('data-end-date')).getTime();
    if (isNaN(endDate)) return;

    if (this._offerCountdownInterval) clearInterval(this._offerCountdownInterval);

    const tick = () => {
      const remaining = endDate - Date.now();
      if (remaining <= 0) {
        countdownEl.textContent = '00:00';
        clearInterval(this._offerCountdownInterval);
        return;
      }
      const totalMinutes = Math.floor(remaining / 1000 / 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const seconds = Math.floor((remaining / 1000) % 60);

      if (hours > 0) {
        countdownEl.textContent =
          String(hours).padStart(2, '0') + 'h : ' +
          String(minutes).padStart(2, '0') + 'm : ' +
          String(seconds).padStart(2, '0') + 's';
      } else {
        countdownEl.textContent =
          String(minutes).padStart(2, '0') + 'm : ' +
          String(seconds).padStart(2, '0') + 's';
      }
    };

    tick();
    this._offerCountdownInterval = setInterval(tick, 1000);
  }

  initProductOfferCheckbox() {
    const productOfferCheckbox = document.getElementById("product-offer-checkbox");
    
    if (!productOfferCheckbox) return;

    productOfferCheckbox.addEventListener("change", (e) => {
      const variantId = e.target.getAttribute("data-variant-id");
      const productId = e.target.getAttribute("data-product-id");

      if (!variantId) {
        console.error("Variant ID not found for product offer");
        return;
      }

      if (e.target.checked) {
        const label = e.target.closest('.product-offer-label');
        if (label) label.classList.add('loading');
        this.addToCart(parseInt(variantId), 1, { _product_offer: 'true', upsell_product: 'true' });
      }
    });
  }

  updateCartItem(line, quantity) {
    let latestCart;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    })
      .then((res) => res.json())
      .then((cartData) => {
        latestCart = cartData;
        /* /cart/change.js returns the full cart — use it directly, no extra fetch */
        if (window.freeGifts?.isFreeGift) {
          this.checkFreeGift(cartData);
        }
        if (window.freeGifts?.onerupeeProductEnable) {
          this.checkExtraGift(cartData);
        }
        /* OLD CODE: cart:updated dispatched first; _fgpOnCartUpdated then had to
         *           fetch /cart.js again, adding a full network round-trip.
         * NEW CODE: pass cartData directly to _fgpScheduleCheck so the FGP check
         *           starts immediately with the already-fetched cart.
         * WHY FASTER: eliminates the redundant /cart.js fetch before gift processing. */
        if (window.fgpConfig?.enabled) {
          this._fgpScheduleCheck(cartData);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cartData }
        }));
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => {
        /* Pass the cart we already fetched through to the drawer refresh so
         * removeUpsellIfAlone can reuse it instead of issuing another /cart.js fetch. */
        this.updateCartDrawer(latestCart);
      });
  }

  addToCart(id, quantity, properties = {}) {
    let latestCart;
    const body = Object.keys(properties).length ? { id, quantity, properties } : { id, quantity };
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then(() => fetch('/cart.js').then((r) => r.json()))
      .then((cartData) => {
        latestCart = cartData;
        /* Single /cart.js fetch — shared by free-gift check and cart:updated */
        if (window.freeGifts?.isFreeGift) {
          this.checkFreeGift(cartData);
        }
        if (window.freeGifts?.onerupeeProductEnable) {
          this.checkExtraGift(cartData);
        }
        /* OLD CODE: cart:updated dispatched first; _fgpOnCartUpdated then had to
         *           fetch /cart.js again, adding another full network round-trip.
         * NEW CODE: pass cartData directly to _fgpScheduleCheck so the FGP check
         *           starts immediately with the already-fetched cart.
         * WHY FASTER: eliminates the duplicate /cart.js fetch before gift processing. */
        if (window.fgpConfig?.enabled) {
          this._fgpScheduleCheck(cartData);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cartData }
        }));
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => {
        /* Pass the cart we already fetched through to the drawer refresh so
         * removeUpsellIfAlone can reuse it instead of issuing another /cart.js fetch. */
        this.updateCartDrawer(latestCart);
      });
  }

  updateCartDrawer(freshCart = null) {
    clearTimeout(this._drawerUpdateTimer);
    if (this._drawerAbortController) this._drawerAbortController.abort();
    /* Carry an already-fetched cart through the debounce so removeUpsellIfAlone
     * can reuse it instead of re-fetching /cart.js. Only the last call's cart
     * matters, same as the existing debounce semantics. */
    this._pendingUpsellCart = freshCart;
    this._drawerUpdateTimer = setTimeout(() => this._executeDrawerUpdate(), 80);
    return Promise.resolve();
  }

  removeUpsellIfAlone = async (cart = null) => {
    try {
      /* Reuse a cart fetched moments earlier by the triggering action instead of
       * re-fetching /cart.js; fall back to a fresh fetch when none was supplied. */
      if (!cart || !Array.isArray(cart.items)) {
        const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
        cart = await res.json();
      }
      const isUpsell = (item) =>
        item.properties &&
        (item.properties.upsell_product === 'true' || item.properties.upsell_product === true);
      const upsellItems = cart.items.filter(isUpsell);
      const nonUpsellItems = cart.items.filter((item) => !isUpsell(item));
      if (upsellItems.length > 0 && nonUpsellItems.length === 0) {
        await Promise.all(
          upsellItems.map((item) =>
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            })
          )
        );
        window.updateCustomCartDrawer();
      }
    } catch (err) {
      console.error('Error checking upsell product:', err);
    }
  };

  _executeDrawerUpdate() {
    this._drawerAbortController = new AbortController();
    const cartDrawerSection = document.querySelector(".cart-drawer-section");
    if (!cartDrawerSection) return;
    const sectionId = cartDrawerSection.getAttribute("data-section-id");
    return fetch(`/?section_id=${sectionId}`, { signal: this._drawerAbortController.signal })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const newCartDrawer = parser
          .parseFromString(html, "text/html")
          .getElementById("cart-drawer-custom");
        const count = newCartDrawer.getAttribute("cart-item");
        const cart_count = document.querySelectorAll(
          "open-minicart #cart-notification-count"
        );
        if (cart_count.length > 0) {
          cart_count.forEach((item) => {
            item.innerHTML = count;
          });
        }
        if (newCartDrawer) {
          //this.cartDrawer.innerHTML = newCartDrawer.innerHTML;
          const header = newCartDrawer.querySelector(".cart-header");
          const updatedHeader = this.cartDrawer.querySelector(".cart-header");
          if (updatedHeader) {
            updatedHeader.innerHTML = header.innerHTML;
            updatedHeader.classList.toggle("has-items", header.classList.contains("has-items"));
          }
          const cartItemList = newCartDrawer.querySelector(".cart-items");
          const updatedCartItemList =
            this.cartDrawer.querySelector(".cart-items");
          if (updatedCartItemList) {
            updatedCartItemList.innerHTML = cartItemList.innerHTML;
          }
          const freeGiftSection = newCartDrawer.querySelector(
            ".free-gift-container-wrapper"
          );
          const updatedFreeGiftSection = this.cartDrawer.querySelector(
            ".free-gift-container-wrapper"
          );
          if (freeGiftSection && updatedFreeGiftSection) {
            updatedFreeGiftSection.innerHTML = freeGiftSection.innerHTML;
          } else if (freeGiftSection && !updatedFreeGiftSection) {
            const cartItemsContainer = this.cartDrawer.querySelector(".cart-items");
            if (cartItemsContainer) {
              cartItemsContainer.insertAdjacentElement(
                "beforebegin",
                freeGiftSection.cloneNode(true)
              );
            }
          } else if (!freeGiftSection && updatedFreeGiftSection) {
            updatedFreeGiftSection.remove();
          }
          const totalPrice = newCartDrawer.querySelector(
            ".cart-footer .subtotal"
          );
          const updatedTotalPrice = this.cartDrawer.querySelector(
            ".cart-footer .subtotal"
          );
          if (updatedTotalPrice) {
            updatedTotalPrice.innerHTML = totalPrice.innerHTML;
          }
          const totalItem = newCartDrawer
            .querySelector(".cart-footer .subtotal")
            .getAttribute("data-count");
          const discountForm = newCartDrawer.querySelector(
            ".discount-form-container"
          );
          const updatedDiscountForm = this.cartDrawer.querySelector(
            ".discount-form-container"
          );
          const discountApplied = newCartDrawer.querySelector(
            ".discount-applied-wrapper"
          );
          const updatedDiscountApplied = this.cartDrawer.querySelector(
            ".discount-applied-wrapper"
          );
          const discountOption =
            newCartDrawer.querySelector(".discount-option");
          const updatedDiscountOption =
            this.cartDrawer.querySelector(".discount-option");
          if (updatedDiscountForm) {
            updatedDiscountForm.innerHTML = discountForm.innerHTML;
          }
          if (updatedDiscountApplied) {
            updatedDiscountApplied.innerHTML = discountApplied.innerHTML;
          }
          if (updatedDiscountOption) {
            updatedDiscountOption.innerHTML = discountOption ? discountOption.innerHTML : '';
            // const hasContent = updatedDiscountOption.querySelector('.discount-option-js, .discount-percent-badge');
            // updatedDiscountOption.style.display = hasContent ? '' : 'none';
          }
          const newDiscountBanner = newCartDrawer.querySelector(".discount-banner");
          const existingDiscountBanner = this.cartDrawer.querySelector(".discount-banner");
          if (existingDiscountBanner) {
            existingDiscountBanner.style.display = newDiscountBanner ? "" : "none";
          }
          const freeGiftDrawer =
            newCartDrawer.querySelector(".free-gift-drawer");
          const updatedFreeGiftDrawer =
            this.cartDrawer.querySelector(".free-gift-drawer");
          if (updatedFreeGiftDrawer) {
            updatedFreeGiftDrawer.innerHTML = freeGiftDrawer.innerHTML;
          }
          if (totalItem < 1) {
            const footer = document.querySelector(".cart-footer");
            if (footer) {
              footer.style.display = "none";
            }
          } else {
            const footer = document.querySelector(".cart-footer");
            if (footer) {
              footer.style.display = "block";
            }
          }

          this.initQuantityButtons();
          this.updateQuantityButtonStates();
          this.removeCartItem();
          this.initCloseCart();
          this.initRecommendedButtons();
          this.initRecommendedSwiper();
          this.applyCoponCode();
          this.initPriceUpdate();
          this.initFreeGiftButtons();
          this.initProductOfferCheckbox();
          this.initOfferCountdown();
          this.removeUpsellIfAlone(this._pendingUpsellCart);

          const checkoutWrapper = document.querySelector(
            ".gokwik-checkout-wrapper-button"
          );
          const checkoutButton = checkoutWrapper?.querySelector("button");

          const rupeesEl = newCartDrawer.querySelector(
            ".cart-footer .subtotal .rupees"
          );

          if (!rupeesEl) return;

          const cartPrice = Number(rupeesEl.getAttribute("data-price")) || 0;
          const isFreeGift = rupeesEl.getAttribute("data-free-gift") === "true";
          const giftThreshold = Number(window.freeGifts?.price) || 0;
          const isExtraGift =
            rupeesEl.getAttribute("data-extra-gift") === "true";

          // Apply logic
          // if (cartPrice <= 0) {
          //   this.disableCheckout();
          // } else if (isFreeGift && cartPrice < giftThreshold) {
          //   this.disableCheckout();
          // }
          // else if (!isExtraGift) {
          //   this.disableCheckout();
          // }
          //  else {
          //   this.enableCheckout();
          // }

          // for free gift
          if (isFreeGift && cartPrice < giftThreshold) {
            this.disableCheckout();
          } else {
            this.enableCheckout();
          }
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.error("Error:", err);
      })
      .finally(() => {
        this._drawerAbortController = null;
        this.removeCheckoutButtonDisabled();
      });
  }

  /* Fetch fresh cart, remove any free-gift items that no longer meet their
   * threshold. Runs inside the shared mutex so it never races with ongoing
   * gift add/remove operations from the FGP gift processor.
   * Returns a Promise that resolves once all invalid gifts are removed. */
  _validateBeforeCheckout() {
    return this._withGiftLock(() => {
      return fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          var removals = [];

          /* --- Legacy freeGifts system --- */
          if (window.freeGifts?.isFreeGift && window.freeGifts?.price > 0) {
            var legacyThreshold = window.freeGifts.price;
            cart.items.forEach((item) => {
              if (item.properties &&
                  (item.properties._free_gift === 'true' || item.properties._free_gift === true)) {
                var cartTotal = Math.max(0, cart.total_price - (item.line_price || 0));
                if (cartTotal < legacyThreshold && !removals.includes(item.key)) {
                  removals.push(item.key);
                }
              }
            });
          }

          /* --- FGP tier system --- */
          if (window.fgpConfig?.enabled) {
            var cfg = window.fgpConfig;
            var adjustedTotal = cart.total_price || 0;
            cart.items.forEach((item) => {
              if (item.properties &&
                  (item.properties._free_gift === 'true' || item.properties._free_gift === true)) {
                adjustedTotal -= (item.line_price || 0);
              }
            });
            adjustedTotal = Math.max(0, adjustedTotal);

            [cfg.tier1, cfg.tier2, cfg.tier3?.valid ? cfg.tier3 : null].forEach((tier) => {
              if (!tier || !tier.productId || !(tier.threshold > 0)) return;
              cart.items.forEach((item) => {
                if (item.product_id === tier.productId &&
                    item.properties &&
                    (item.properties._free_gift === 'true' || item.properties._free_gift === true) &&
                    adjustedTotal < tier.threshold &&
                    !removals.includes(item.key)) {
                  removals.push(item.key);
                }
              });
            });
          }

          if (removals.length === 0) return;

          return removals.reduce((chain, key) => {
            return chain.then(() =>
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
              }).then((r) => r.json())
            );
          }, Promise.resolve());
        });
    });
  }

  /* ── FGP: Shared mutex setup ──────────────────────────────────────────
   * Exposes window._fgpLock / window._withGiftLock so every gift
   * add/remove operation is serialised — no concurrent race conditions. */
  _fgpSetupMutex = () => {
    if (!window._fgpLock) window._fgpLock = Promise.resolve();
    if (!window._withGiftLock) {
      window._withGiftLock = (fn) => {
        let release;
        const slot = new Promise((resolve) => { release = resolve; });
        const prev = window._fgpLock;
        window._fgpLock = slot;
        return prev.then(() =>
          Promise.resolve().then(fn).finally(() => release())
        );
      };
    }
  };

  /* ── FGP: Validation helpers ─────────────────────────────────────────── */
  _fgpIsValidCart = (cart) =>
    !!(cart && typeof cart === 'object' && Array.isArray(cart.items));

  _fgpGetAdjustedTotal = (cart) => {
    if (!this._fgpIsValidCart(cart)) return 0;
    let total = cart.total_price || 0;
    cart.items.forEach((item) => {
      if (item?.properties &&
          (item.properties._free_gift === 'true' || item.properties._free_gift === true)) {
        total -= (item.line_price || 0);
      }
    });
    return Math.max(0, total);
  };

  _fgpHasGift = (cart, productId) => {
    if (!this._fgpIsValidCart(cart)) return false;
    return cart.items.some((item) =>
      item &&
      item.product_id === productId &&
      item.properties &&
      (item.properties._free_gift === 'true' || item.properties._free_gift === true)
    );
  };

  _fgpFindGiftKey = (cart, productId) => {
    if (!this._fgpIsValidCart(cart)) return null;
    for (const item of cart.items) {
      if (item && item.product_id === productId &&
          item.properties &&
          (item.properties._free_gift === 'true' || item.properties._free_gift === true)) {
        return item.key;
      }
    }
    return null;
  };

  /* ── FGP: Cart API helpers ───────────────────────────────────────────── */
  _fgpAddGift = (variantId) =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: { _free_gift: 'true' } })
    }).then((r) => {
      if (!r.ok) return r.json().catch(() => ({})).then((b) => {
        throw new Error('Gift add failed (' + r.status + '): ' + (b.description || b.message || 'unknown'));
      });
      return r.json();
    });

  _fgpAddGifts = (variantIds) => {
    if (variantIds.length === 1) return this._fgpAddGift(variantIds[0]);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: variantIds.map((id) => ({ id, quantity: 1, properties: { _free_gift: 'true' } }))
      })
    }).then((r) => {
      if (!r.ok) return r.json().catch(() => ({})).then((b) => {
        console.warn('[FGP] Batch add rejected — sequential fallback');
        return variantIds.reduce((chain, id) => chain.then(() => this._fgpAddGift(id)), Promise.resolve());
      });
      return r.json();
    });
  };

  _fgpRemoveGift = (itemKey) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: 0 })
    }).then((r) => {
      if (!r.ok) return r.json().catch(() => ({})).then((b) => {
        throw new Error('Gift remove failed (' + r.status + '): ' + (b.description || b.message || 'unknown'));
      });
      return r.json();
    });

  /* ── FGP: Progress bar — pure DOM update, no network call ───────────── */
  _fgpPatchProgressBar = (total) => {
    const cfg = window.fgpConfig;
    const container = document.querySelector('#cart-drawer-custom .fgp-container');
    if (!container) return;
    const progressPoints = Array.from(container.querySelectorAll('.fgp-milestone'))
      .map((milestone) => ({
        threshold: Number(cfg[`tier${milestone.dataset.fgpTier}`]?.threshold) || 0,
        position: Number.parseFloat(milestone.style.left)
      }))
      .filter((point) => point.threshold > 0 && Number.isFinite(point.position));
    let percent = 0;
    let previousThreshold = 0;
    let previousPosition = 0;
    for (const point of progressPoints) {
      if (total < point.threshold) {
        const thresholdSpan = point.threshold - previousThreshold;
        const progress = thresholdSpan > 0
          ? Math.max(0, Math.min(1, (total - previousThreshold) / thresholdSpan))
          : 0;
        percent = previousPosition + (point.position - previousPosition) * progress;
        break;
      }
      previousThreshold = point.threshold;
      previousPosition = point.position;
      percent = point.position;
    }
    const fill = container.querySelector('.fgp-fill');
    if (fill) fill.style.width = percent + '%';
    const milestones = container.querySelectorAll('.fgp-milestone');
    milestones.forEach((milestone) => {
      const tier = cfg[`tier${milestone.dataset.fgpTier}`];
      const threshold = Number(tier?.threshold) || 0;
      milestone.classList.toggle('fgp-milestone--unlocked', threshold > 0 && total >= threshold);
    });
  };

  /* ── FGP: Core processor — adds/removes gifts based on tier thresholds ─ */
  _fgpProcessGifts = (cart) => {
    if (!this._fgpIsValidCart(cart)) return Promise.resolve(false);
    const cfg = window.fgpConfig;
    const total = this._fgpGetAdjustedTotal(cart);
    const toAdd = [];
    const toRemove = [];

    const t1 = cfg.tier1;
    if (t1?.variantId && t1?.productId && t1.threshold > 0) {
      const has1 = this._fgpHasGift(cart, t1.productId);
      if (total >= t1.threshold && !has1) {
        toAdd.push(t1.variantId);
      } else if (total < t1.threshold && has1) {
        const key1 = this._fgpFindGiftKey(cart, t1.productId);
        if (key1) toRemove.push(key1);
      }
    }

    const t2 = cfg.tier2;
    if (t2?.variantId && t2?.productId && t2.threshold > 0) {
      const has2 = this._fgpHasGift(cart, t2.productId);
      if (total >= t2.threshold && !has2) {
        toAdd.push(t2.variantId);
      } else if (total < t2.threshold && has2) {
        const key2 = this._fgpFindGiftKey(cart, t2.productId);
        if (key2) toRemove.push(key2);
      }
    }

    const t3 = cfg.tier3;
    if (t3?.valid && t3?.variantId && t3?.productId && t3.threshold > t2.threshold) {
      const has3 = this._fgpHasGift(cart, t3.productId);
      if (total >= t3.threshold && !has3) {
        toAdd.push(t3.variantId);
      } else if (total < t3.threshold && has3) {
        const key3 = this._fgpFindGiftKey(cart, t3.productId);
        if (key3) toRemove.push(key3);
      }
    }

    if (toAdd.length === 0 && toRemove.length === 0) return Promise.resolve(false);

    let ops = Promise.resolve();
    if (toAdd.length > 0) ops = ops.then(() => this._fgpAddGifts(toAdd));
    toRemove.forEach((key) => { ops = ops.then(() => this._fgpRemoveGift(key)); });

    return ops
      .then(() => true)
      .catch((e) => { console.error('[FGP]', e); return false; });
  };

  /* ── FGP: Run check — uses provided cart or falls back to fetching ──── */
  /* OLD CODE: always fetched /cart.js inside the lock, adding ~200–500ms
   *           network latency before every gift add/remove decision.
   * NEW CODE: accepts a cart object directly when available.
   * WHY FASTER: skips the redundant fetch when caller already has fresh cart
   *             data (from /cart/change.js or /cart/add.js responses).
   *             Falls back to fetching when called without a valid cart
   *             (e.g. initial page load, event listener without cart detail). */
  _fgpRunCheck = (cart) => {
    const execute = (cartToProcess) => {
      /* Disable checkout for the duration of any gift add/remove so the
       * customer cannot proceed with an inconsistent cart mid-operation. */
      this.checkoutButtonDisabled();
      this._withGiftLock(() => {
        this._fgpPatchProgressBar(this._fgpGetAdjustedTotal(cartToProcess));
        return this._fgpProcessGifts(cartToProcess);
      })
      .then((changed) => {
        if (changed) {
          /* updateCartDrawer calls removeCheckoutButtonDisabled in its .finally() */
          this.updateCartDrawer();
        } else {
          /* No gift change — re-enable immediately; no drawer refresh needed. */
          this.removeCheckoutButtonDisabled();
        }
      })
      .catch((err) => {
        console.error('[FGP RUNCHECK]', err);
        /* Always re-enable on error so the customer is never stuck. */
        this.removeCheckoutButtonDisabled();
      });
    };

    if (this._fgpIsValidCart(cart)) {
      execute(cart);
    } else {
      fetch('/cart.js').then((r) => r.json())
        .then((freshCart) => execute(freshCart))
        .catch((err) => console.error('[FGP RUNCHECK]', err));
    }
  };

  /* ── FGP: Debounced schedule — patches bar immediately, checks after 10ms */
  _fgpScheduleCheck = (hintCart) => {
    clearTimeout(this._fgpRunCheckTimer);
    if (this._fgpIsValidCart(hintCart)) {
      /* Synchronous DOM patch — zero latency progress bar update. */
      this._fgpPatchProgressBar(this._fgpGetAdjustedTotal(hintCart));
    }
    /* OLD CODE: setTimeout(this._fgpRunCheck, 80)
     *           — did not forward hintCart, so _fgpRunCheck always fetched /cart.js.
     * NEW CODE: 10ms debounce, hintCart forwarded to _fgpRunCheck.
     * WHY SAFE:  rapid successive calls are still collapsed by clearTimeout above;
     *            10ms is enough to coalesce any synchronous call pairs (e.g. direct
     *            call + cart:updated listener) without causing race conditions.
     * WHY FASTER: hintCart reuse cuts the /cart.js round-trip (~200–500ms) from
     *             every gift check triggered by a user cart action. */
    this._fgpRunCheckTimer = setTimeout(() => {
      this._fgpRunCheck(hintCart);
    }, 10);
  };

  /* ── FGP: cart:updated listener ─────────────────────────────────────── */
  _fgpOnCartUpdated = (event) => {
    const cart = (
      event?.detail?.cart &&
      Array.isArray(event.detail.cart.items) &&
      typeof event.detail.cart.total_price === 'number'
    ) ? event.detail.cart : null;

    if (!cart) {
      fetch('/cart.js').then((r) => r.json())
        .then((freshCart) => this._fgpScheduleCheck(freshCart))
        .catch((err) => console.error('[FGP EVENT]', err));
      return;
    }
    this._fgpScheduleCheck(cart);
  };

  /* ── FGP: Initialization — registers listener and runs initial check ── */
  _fgpInitialize = () => {
    if (!window.fgpConfig?.enabled) return;
    document.addEventListener('cart:updated', this._fgpOnCartUpdated);
    const initCart = window.fgpCartData || null;
    if (this._fgpIsValidCart(initCart)) {
      this._fgpScheduleCheck(initCart);
    } else {
      fetch('/cart.js').then((r) => r.json())
        .then((cart) => this._fgpScheduleCheck(cart))
        .catch((err) => console.error('[FGP INIT]', err));
    }
  };

  applyCoponCode() {
    let clearBtn = document.querySelectorAll("#clear-discount-btn");
    let applyBtn = document.querySelector("#apply-discount-btn");
    let directApplyBtn = document.querySelector(".discount-option-js");
    let discountCodeError = document.querySelector("#discount-code-error");
    let discountCodeWrapper = document.querySelector(
      "#applied-discount-code .applied-discount-code-wrapper"
    );

    let discountCodeInput = document.querySelector("#discount-code-input");
    let totalCartSelector = document.querySelector(".cart__subtotal .money"); // Total Cart Selector to update the total amount.
    let authorization_token;

    let checkoutContainer = document.createElement("div");
    document.body.appendChild(checkoutContainer);
    if (applyBtn)
      applyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.checkoutButtonDisabled();
        applyDiscount(discountCodeInput.value);
      });
    if (clearBtn.length > 0) {
      clearBtn.forEach((ele) => {
        ele.addEventListener("click", (e) => {
          e.preventDefault();
          this.checkoutButtonDisabled();
          const discountWrapper = ele.closest(
            ".DiscountCodeBadge-discountBadge"
          );
          if (discountWrapper) {
            discountWrapper.classList.add("pending");
          }
          clearDiscount();
        });
      });
    }

    if (directApplyBtn) {
      directApplyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.checkoutButtonDisabled();
        const discountCode = directApplyBtn.getAttribute("data-discount");
        discountCodeInput.value = discountCode;
        applyDiscount(discountCode);
        window.directUptate = true;
      });
    }
    function clearDiscount() {
      discountCodeError.innerHTML = "";
      clearLocalStorage();

      // Use the correct Shopify endpoint to clear discount
      let latestCart;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: "" })
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Discount cleared successfully:", data);
          /* /cart/update.js already returns the full cart — capture it so the
           * drawer refresh can reuse it instead of re-fetching /cart.js. */
          latestCart = data;
        })
        .catch((error) => {
          console.error("Error clearing discount:", error);
        })
        .finally(() => {
          // Reset apply button state
          if (applyBtn) {
            applyBtn.innerHTML = "Apply";
            applyBtn.style.pointerEvents = "auto";
          }
          window.updateCustomCartDrawer(latestCart);
        });
    }
    function clearLocalStorage() {
      if (discountCodeWrapper) discountCodeWrapper.style.display = "none";
      
      // Safely access localStorage
      if (localStorage.getItem("discountCode")) {
        try {
          const discountData = JSON.parse(localStorage.getItem("discountCode"));
          if (totalCartSelector && discountData.totalCart) {
            totalCartSelector.innerHTML = discountData.totalCart;
          }
        } catch (error) {
          console.error("Error parsing discount data from localStorage:", error);
        }
      }
      localStorage.removeItem("discountCode");
    }
    function applyDiscount(code) {
      if (!code) {
        discountCodeError.innerHTML = "Please enter a discount code";
        setTimeout(() => {
          discountCodeError.innerHTML = "";
        }, 3000);
        return;
      }
      if (applyBtn) {
        applyBtn.innerHTML = "Applying...";
        applyBtn.style.pointerEvents = "none";
      }
      let latestCart;
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: code }),
      })
        .then((response) => response.json())
        .then((data) => {
          /* /cart/update.js already returns the full cart — capture it so the
           * drawer refresh can reuse it instead of re-fetching /cart.js. */
          latestCart = data;
          // Check if discount_codes exists and handle the response properly
          if (data.discount_codes && Array.isArray(data.discount_codes)) {
            data.discount_codes.forEach((ele) => {
              console.log(ele.applicable, "ele.applicable");
              if (ele.applicable === false) {
                discountCodeError.innerHTML = `Discount code "${ele.code}" is invalid`;
                setTimeout(() => {
                  discountCodeError.innerHTML = "";
                }, 3000);
              }
            });
          } else if (data.token) {
            // Successfully applied discount
            console.log("Discount applied successfully:", data);
            if (discountCodeError) {
              discountCodeError.innerHTML = "";
            }
          }
          console.log("Preview data stored:", data);
        })
        .catch((error) => {
          console.error("Error applying discount:", error);
          discountCodeError.innerHTML = "Invalid discount code";
          setTimeout(() => {
            discountCodeError.innerHTML = "";
          }, 3000);
        })
        .finally(() => {
          window.updateCustomCartDrawer(latestCart);
        });
    }
  }
}
var _cartDrawerController = new CartDrawerController();

/* ── CHECKOUT PROTECTION ────────────────────────────────────────────────
 * Intercepts onCheckoutClick (called by every checkout button via onclick).
 * Before delegating to GoKwik (or native /checkout), fetches the latest
 * cart and removes any free-gift items whose threshold is no longer met.
 * A 5-second failsafe ensures the customer is never permanently blocked.
 * ──────────────────────────────────────────────────────────────────────── */
(function () {
  /* GoKwik's own checkout handler — populated on 'gokwikLoaded' */
  var _gkCheckout = null;

  function _proceedToCheckout(btn) {
    if (typeof _gkCheckout === 'function') {
      _gkCheckout(btn);
    } else if (document.querySelector('.gokwik-checkout-wrapper-button, .gokwik-checkout, [class*="gokwik"]')) {
      /* GoKwik elements are present but we don't have their handler yet.
       * Do NOT redirect — GoKwik's own SDK/event-listeners will open the popup.
       * Redirecting here would race against GoKwik and navigate away instead. */
    } else {
      /* GoKwik is absent — fall back to native checkout. */
      window.location.href = '/checkout';
    }
  }

  function _protectedCheckoutClick(btn) {
    var button = btn || document.querySelector('.gokwik-checkout-wrapper-button button, .gokwik-checkout button');
    var loader  = button ? button.querySelector('.addloadr') : null;

    /* Show loading state */
    if (button) {
      button.disabled = true;
      button.classList.add('disabled');
    }
    if (loader) loader.style.display = 'flex';

    /* Failsafe: if validation hangs > 5 s, proceed anyway */
    var failsafeTimer = setTimeout(function () {
      if (loader) loader.style.display = 'none';
      if (button) { button.disabled = false; button.classList.remove('disabled'); }
      _proceedToCheckout(btn);
    }, 5000);

    _cartDrawerController._validateBeforeCheckout()
      .then(function () {
        clearTimeout(failsafeTimer);
        if (loader) loader.style.display = 'none';
        /* Re-enable before handing off — GoKwik checks button.disabled internally. */
        if (button) { button.disabled = false; button.classList.remove('disabled'); }
        _proceedToCheckout(btn);
      })
      .catch(function (err) {
        console.error('[CHECKOUT] Validation error — proceeding anyway:', err);
        clearTimeout(failsafeTimer);
        if (loader) loader.style.display = 'none';
        if (button) { button.disabled = false; button.classList.remove('disabled'); }
        _proceedToCheckout(btn);
      });
  }

  /* ── Capture GoKwik's checkout handler ─────────────────────────────────
   *
   * GoKwik sets window.onCheckoutClick to their popup-opener function.
   * The timing varies — they may run before OR after this script — so we
   * use two complementary strategies instead of relying on one event.
   *
   * Strategy A — GoKwik loaded BEFORE us:
   *   Read the existing window.onCheckoutClick value right now and store it.
   *
   * Strategy B — GoKwik loaded AFTER us:
   *   Object.defineProperty setter intercepts their assignment the instant
   *   it happens. The getter always returns _protectedCheckoutClick so our
   *   validation runs first on every button click.
   *
   * If neither strategy captures a handler (GoKwik uses a different API),
   * _proceedToCheckout will not redirect when GoKwik elements are present
   * on the page — their own SDK click-listeners will open the popup. */

  /* Strategy A: capture any handler GoKwik already set */
  var _preExisting = window.onCheckoutClick;
  if (typeof _preExisting === 'function' && _preExisting !== _protectedCheckoutClick) {
    _gkCheckout = _preExisting;
  }

  /* Strategy B: intercept future assignments */
  try {
    Object.defineProperty(window, 'onCheckoutClick', {
      configurable: true,
      get: function () { return _protectedCheckoutClick; },
      set: function (fn) {
        if (typeof fn === 'function' && fn !== _protectedCheckoutClick) {
          _gkCheckout = fn;
        }
      }
    });
  } catch (e) {
    /* defineProperty blocked — plain assignment + gokwikLoaded fallback */
    window.onCheckoutClick = _protectedCheckoutClick;
    window.addEventListener('gokwikLoaded', function () {
      if (typeof window.onCheckoutClick === 'function' &&
          window.onCheckoutClick !== _protectedCheckoutClick) {
        _gkCheckout = window.onCheckoutClick;
        window.onCheckoutClick = _protectedCheckoutClick;
      }
    });
  }
})();